export default __webpack_public_path__ + "static/media/background_login.37f23a84.png";